<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-header text-center" style="background: none; border-bottom: 0px">
          <p><img src="assets/img/team.png" width="55" height="55" class="ml-4'"></p>
          <p><span class="font-weight-bold text-black-50">PORTAL DO CIDADÃO</span></p>
        </div>
        <div class="card-body">
          <form id="login-form">
            <div *ngIf="msgs" class="alert alert-danger" role="alert">
              {{msgs}}
            </div>
            <div class="col-auto">
              <label class="sr-only" for="email">e-mail</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-user"></i></div>
                </div>
                <input [imask]="maskConfig" unmask="true" type="text" class="form-control" name="email"
                  [(ngModel)]="email" placeholder="Informe o seu e-mail de acesso ou CPF">
              </div>
            </div>

            <div class="col-auto">
              <label class="sr-only" for="senha">Senha</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-lock"></i></div>
                </div>
                <input type="password" class="form-control" name="senha" [(ngModel)]="senha"
                  placeholder="Infome sua senha">
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-8">
                <div class="form-group">
                  <button type="button" class="btn btn-link" (click)="recuperarSenha()">Esqueci a minha senha</button>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <button type="button" (click)="fazerLogin()" class="btn btn-block btn-primary">Entrar</button>
                </div>
              </div>
            </div>
            <div class="col-auto">
              <div class="form-group">
                <p class="text-muted text-xs-center">Não tem uma conta? <button type="button" class="btn btn-link" (click)="registroUsuario()">Cadastre-se!</button></p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
